import React, { useRef } from 'react';
import CommonButton from '../../Components/CommonButton';
import { useNova } from '../NovaContext';
import { NOVA_IDS, TABS } from '../constants';

export default function TabBar() {
    const { state, actions } = useNova();
    const tabRefs = useRef([]);

    const onKeyDown = (event, index) => {
        const last = TABS.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        actions.setTab(TABS[next].id);
        tabRefs.current[next]?.focus();
    };

    return (
        <div className="nova_tabs_bar">
            <div role="tablist" aria-label="Foresee AI sections" className="common_tabs nova_tabs">
                {TABS.map(({ id, label, Icon }, index) => {
                    const active = state.activeTab === id;
                    return (
                        <CommonButton
                            key={id}
                            ref={(node) => { tabRefs.current[index] = node; }}
                            role="tab"
                            id={NOVA_IDS.tab(id)}
                            aria-selected={active}
                            aria-controls={NOVA_IDS.tabpanel(id)}
                            tabIndex={active ? 0 : -1}
                            type="button"
                            variant={active ? undefined : 'white'}
                            className={active ? 'cmn_tab--active' : ''}
                            onClick={() => actions.setTab(id)}
                            onKeyDown={(event) => onKeyDown(event, index)}
                            text={<><Icon size={16} />{label}</>}
                        />
                    );
                })}
            </div>
        </div>
    );
}
